import { Box, Divider, Paper, PaperProps, Theme, Typography } from '@mui/material';
import isString from 'lodash/isString';
import { ReactNode, useMemo } from 'react';

interface Props extends Omit<PaperProps, 'title'> {
    title?: string | ReactNode;
}

const dividerStyles = {
    borderBottomWidth: 2,
};
export const Card = ({ title, children, sx, ...props }: Props) => {
    const paperStyles = useMemo(
        () => ({
            padding: 2,
            minWidth: { xs: '90%', sm: 450 },
            borderRadius: '2px',
            ...sx,
        }),
        [sx],
    );

    return (
        <Paper sx={paperStyles} elevation={2} {...props}>
            {title && (
                <Box>
                    {isString(title) ? (
                        <Typography variant="h4" textAlign="center" mb={1}>
                            {title}
                        </Typography>
                    ) : (
                        title
                    )}
                    <Divider sx={dividerStyles} />
                </Box>
            )}
            {children}
        </Paper>
    );
};
